import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {Challenge} from '@/app/core/models/p-place/pixel';

@Injectable({
	providedIn: 'root'
})
export class ChallengeService {

	constructor(
		private readonly http: HttpClient
	) {}

	private readonly SERVICE_URI = `${environment.backendUrl}/place/challenge`;

	getChallenges(): Observable<Challenge[]> {
		return this.http.get<Challenge[]>(
			this.SERVICE_URI
		);
	}

}
